/**
 * Announcement bar: sticky until scroll past threshold (50% viewport), then hide.
 * Re-show when scrolling back up.
 */
(function() {
  function init() {
    var wrapper = document.getElementById('announcement-sticky');
    if (!wrapper) return;

    // Always pinned: never hide on scroll.
    wrapper.classList.remove('announcement-bar-unstick');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
